module.exports = __webpack_public_path__ + "img/coupon.599c2f8c.svg";